import { toBigWithDefault, type Security } from '@talos/kyoko';

export interface CustomerTradeQuantityCurrency {
  displayCurrency: string | undefined;
  requestCurrency: string | undefined;
}

export function getCustomerTradeQuantityCurrency(
  security: Security | undefined,
  supportNotionalMultiplierInCustomerTrade: boolean
): CustomerTradeQuantityCurrency {
  if (!security?.BaseCurrency) {
    return { displayCurrency: undefined, requestCurrency: undefined };
  }

  const usePositionCurrency =
    supportNotionalMultiplierInCustomerTrade && !toBigWithDefault(security.NotionalMultiplier, 1).eq(1);

  if (!usePositionCurrency) {
    return {
      displayCurrency: security.BaseCurrency,
      requestCurrency: security.BaseCurrency,
    };
  }

  const positionCurrency = security.PositionCurrency;
  if (!positionCurrency) {
    return { displayCurrency: undefined, requestCurrency: undefined };
  }

  return {
    displayCurrency: positionCurrency,
    requestCurrency: positionCurrency,
  };
}
